export const formInitialValues = {
  description: '',
  product_link: '',
  topic_ids: [],
  industry_ids: [],
};
